import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import iconSrc from '../assets/icon.png';
import { PromotionWarningWrapper } from './PromotionWarningWrapper';

interface IProps {
  mobile: boolean;
  text: string;
}

export const PromotionTypeChangeWarning = ({ mobile, text }: IProps) => (
  <PromotionWarningWrapper icon={<img height="44px" src={iconSrc} />}>
    {!mobile && <UIText2 fontWeight="bold">Активное продвижение ещё не закончилось</UIText2>}
    {text}
  </PromotionWarningWrapper>
);
